import React from 'react'
import { SvgIconProps } from './Home'

const SvgCheckboxCheckedIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="66"
    height="20"
    fill="none"
    viewBox="0 0 66 20"
  >
    <rect
      width="19"
      height="19"
      x="0.5"
      y="0.5"
      fill="#fff"
      stroke="#C7C7C7"
      rx="2.5"
    ></rect>
    <path
      fill={fill ?? "#95358F"}
      d="M15.913 6.449c-.047-.152-.143-.203-.239-.304l-.813-.86-.048-.05a.895.895 0 00-1.147-.051l-.144.152-5.02 5.313c-.097.1-.144.151-.24.253L6.54 9.08c-.143-.152-.239-.304-.478-.354-.239-.101-.526-.05-.765.101-.095.05-.191.152-.239.202l-.574.608c-.143.1-.239.253-.335.354-.239.405-.19.91.144 1.214l3.252 3.44c.095.102.239.254.43.304.096.051.191.051.287.051a.92.92 0 00.67-.304l4.112-4.351 2.535-2.682c.095-.101.19-.202.287-.354.143-.202.19-.557.047-.86z"
    ></path>
  </svg>
)


export default SvgCheckboxCheckedIcon